// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"6d0545eb","84":"1e0e5950","279":"e8c9ad37","449":"f5d2c4d4","771":"01ab8779"}[chunkId] + ".chunk.js";
};